import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import { ManualGradingConfigurationPut } from './actions';

import messages from './messages';
import { ACTION, RTM_OPERATION, RTM_REPLY } from './constants';

function* storeManualGradeConfiguration({ response: { manualGradingConfiguration } }) {
  yield put(ManualGradingConfigurationPut(manualGradingConfiguration.componentId, manualGradingConfiguration.maxScore, true));
}

function* removeManualGradeConfiguration({ response: { manualGradingConfiguration } }) {
  yield put(ManualGradingConfigurationPut(manualGradingConfiguration.componentId, undefined, false));
}

export function* sendRequest(connection, rtmMessages = {}, action) {
  const response = yield call(connection.fetch.bind(connection), {
    type: rtmMessages.sendMessage,
    componentId: action.componentId,
    maxScore: action.maxScore,
  });
  const responseAction = rtmMessages[response.type];
  if (!responseAction) {
    yield call(handleError, response, messages.defaultError);
  } else {
    yield call(responseAction, response);
  }
}

export function* handleError(err, message) {
  yield put(pushToast({
    type: 'simple',
    message: err.message || <FormattedMessage {...message} />,
  }));
}

export default function* (connection) {
  yield takeEvery(ACTION.AUTHOR_MANUAL_GRADING_CONFIGURATION_GET, catchErrors, sendRequest, connection, {
    sendMessage: RTM_OPERATION.AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_GET,
    [RTM_REPLY.AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_GET_OK]: (response) => storeManualGradeConfiguration(response),
    [RTM_REPLY.AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_GET_ERROR]: handleError });

  yield takeEvery(ACTION.AUTHOR_MANUAL_GRADING_CONFIGURATION_SET, catchErrors, sendRequest, connection, {
    sendMessage: RTM_OPERATION.AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_SET,
    [RTM_REPLY.AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_SET_OK]: (response) => storeManualGradeConfiguration(response),
    [RTM_REPLY.AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_SET_ERROR]: handleError });

  yield takeEvery(ACTION.AUTHOR_MANUAL_GRADING_CONFIGURATION_DELETE, catchErrors, sendRequest, connection, {
    sendMessage: RTM_OPERATION.AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_DELETE,
    [RTM_REPLY.AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_DELETE_OK]: (response) => removeManualGradeConfiguration(response),
    [RTM_REPLY.AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_DELETE_ERROR]: handleError });
}
